import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "angle-up",
  "use": "angle-up-usage",
  "viewBox": "0 0 438 266",
  "content": "<symbol viewBox=\"0 0 438 266\" xmlns=\"http://www.w3.org/2000/svg\" id=\"angle-up\"><path d=\"M235.97 7.523l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04l-154.746-154.02L64.254 258.515c-9.379 9.335-24.544 9.317-33.901-.04L7.686 235.808c-9.373-9.373-9.373-24.569 0-33.941L202.029 7.524c9.372-9.373 24.568-9.373 33.941-.001z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol